export default "__VITE_ASSET__Crkye0W2__"